import type {ImageField, LinkField, RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {
  CustomerStoriesV2SliceAutoplayPrimaryCustomerStoriesItem,
  CustomerStoriesV2SliceReskinPrimaryCustomerStoriesItem,
  CustomerStoryDocumentData,
} from 'prismicio-types'

const extractTitleText = (title?: RichTextField): string => {
  const firstNode = title?.[0]

  if (firstNode && 'text' in firstNode) {
    return firstNode.text
  }

  return ''
}

type CardItem =
  CustomerStoriesV2SliceAutoplayPrimaryCustomerStoriesItem | CustomerStoriesV2SliceReskinPrimaryCustomerStoriesItem

export type ResolvedCard = CardItem & {
  title: string
  image: ImageField
  company_logo?: ImageField
  primary_button_url: LinkField
}

export const resolveCardFromDocument = (card: CardItem): ResolvedCard => {
  const doc =
    'customer_story_document' in card && isFilled.contentRelationship(card.customer_story_document)
      ? card.customer_story_document
      : undefined

  const data = doc?.data as CustomerStoryDocumentData | undefined

  return {
    ...card,
    title: data ? extractTitleText(data.title) : '',
    image: data?.image ?? ({} as ImageField),
    primary_button_url: isFilled.link(card.primary_button_url)
      ? card.primary_button_url
      : (doc ?? card.primary_button_url),
    company_logo: data?.company_logo,
  } as ResolvedCard
}
